export const MENUANDPAGES_LOADING = 'REDUX_SAGA_MENUANDPAGES_LOADING';
export const GET_MENUANDPAGES_DATA_SUCCESS = 'REDUX_SAGA_GET_MENUANDPAGES_DATA_SUCCESS';
export const RESET_MENUANDPAGES = "REDUX_SAGA_RESET_MENUANDPAGES";
export const GET_MENUANDPAGES_DATA_ERROR = 'REDUX_SAGA_GET_MENUANDPAGES_DATA_ERROR';

export const actionGetMenuAndPages = (dispatch, applicationId) => {
    dispatch({ type: MENUANDPAGES_LOADING, applicationId: applicationId })
};

export const actionResetMenuAndPages = (dispatch) => {
    dispatch({ type: RESET_MENUANDPAGES })
};
